var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-home-d-block"},[_c('div',{class:['default-c-box', _vm.component.action.config.isShow ? '' : 'block-hide']},[_c('img',{attrs:{"src":"https://oss.zheyi360.com/app-image/home-config/hotSale.png","alt":"爆品库"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }